import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useNavigate } from "react-router-dom"; // Add this import
import DataTableMUI from "../../components/common/DataTable";
import { donorReviewColumns } from "../../services/tableColomn";
import ViewDataPopup from "./viewDataPopup";
import {
  deleteDonorReview,
  getAllDonorReviews,
  undoDeleteDonorReview,
} from "../../redux/slices/donorReviewSlice";

const statusOptions = [
  { value: "all", label: "ALL", color: "#2563eb" },
  { value: "active", label: "ACTIVE", color: "#388e3c" },
  { value: "inactive", label: "INACTIVE", color: "#bfa100" },
  { value: "deleted", label: "DELETED", color: "#d32f2f" },
];

const DonorReview = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate(); // Add this
  const { donorReview, loading, statusCounts, pagination } = useAppSelector(
    (state) => state.donorReview
  );

  // Remove showForm and editData states since we're navigating
  const [viewPopupOpen, setViewPopupOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [statusFilter, setStatusFilter] = useState("all");
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortKey, setSortKey] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    dispatch(
      getAllDonorReviews({
        status: statusFilter,
        page,
        search,
        limit: itemsPerPage,
        sortKey,
        sortOrder,
      })
    );
  }, [dispatch, statusFilter, page, search, itemsPerPage, sortKey, sortOrder]);

  const refetch = () =>
    dispatch(
      getAllDonorReviews({
        status: statusFilter,
        page,
        search,
        limit: itemsPerPage,
        sortKey,
        sortOrder,
      })
    );

  const handleStatusChange = (status) => {
    setStatusFilter(status);
    setPage(1);
  };

  const handlePageChange = (newPage) => setPage(newPage);
  const handleView = (row) => {
    setSelectedRow(row);
    setViewPopupOpen(true);
  };

  // Update handleEdit to navigate with data
  const handleEdit = (row) => {
    navigate("/donor-review-form", {
      state: { editData: row },
    });
  };

  const handleDelete = async (row) => {
    if (window.confirm("Are you sure you want to delete this donor review?")) {
      try {
        await dispatch(deleteDonorReview(row._id));
        refetch();
      } catch (error) {
        console.error("Delete failed:", error);
      }
    }
  };

  const handleUndo = async (row) => {
    await dispatch(undoDeleteDonorReview(row._id));
    refetch();
  };
  const handleSort = (col) => {
    if (!col.sortable) return;
    setSortKey(col.accessor);
    setSortOrder(
      sortKey === col.accessor && sortOrder === "asc" ? "desc" : "asc"
    );
    setPage(1);
  };
  const handleSearch = () => {
    setSearch(searchInput);
    setPage(1);
  };

  // Add counts to statusOptions
  const statusOpts = statusOptions.map((opt) => ({
    ...opt,
    count: statusCounts?.[opt.value] || 0,
  }));

  return (
    <div className="data-table">
      <DataTableMUI
        title="Donor Review"
        columns={donorReviewColumns}
        data={donorReview || []}
        statusOptions={statusOpts}
        statusCounts={statusCounts}
        statusFilter={statusFilter}
        onStatusFilterChange={handleStatusChange}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onUndo={handleUndo}
        pagination
        itemsPerPage={itemsPerPage}
        currentPage={pagination?.page || 1}
        totalItems={pagination?.total || 0}
        setItemsPerPage={setItemsPerPage}
        onPageChange={handlePageChange}
        searchable
        searchTerm={searchInput}
        setSearchTerm={setSearchInput}
        onSearch={handleSearch}
        onAdd
        onAddClick={() => navigate("/donor-review-form")} // Navigate for Add
        loading={loading}
        sortKey={sortKey}
        sortOrder={sortOrder}
        onSort={handleSort}
      />

      {selectedRow && (
        <ViewDataPopup
          open={viewPopupOpen}
          onClose={() => {
            setViewPopupOpen(false);
            setSelectedRow(null);
          }}
          data={selectedRow}
        />
      )}
    </div>
  );
};

export default DonorReview;
